module.exports = __webpack_public_path__ + "img/episode1.3c4e669f.png";